import { Component } from '@angular/core';

@Component({
  selector: 'app-graduation-cap-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './graduation-cap-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class GraduationCapIconComponent {}
